import { FLAGGED_CANCELLATIONS_UI_VISIBLE } from 'data/constants/featureFlags';

export const FLAGGED_CANCELLATION_TAB_SLUG = 'flagged-cancellation';

export const isFlaggedCancellationsUiVisible = () => FLAGGED_CANCELLATIONS_UI_VISIBLE;

export const filterFlaggedCancellationDetailTabs = (tabSlugs, tabs) => {
  if (FLAGGED_CANCELLATIONS_UI_VISIBLE) {
    return { tabSlugs, tabs };
  }

  const filtered = tabSlugs
    .map((slug, index) => ({ slug, tab: tabs[index] }))
    .filter(({ slug }) => slug !== FLAGGED_CANCELLATION_TAB_SLUG);

  return {
    tabSlugs: filtered.map(({ slug }) => slug),
    tabs: filtered.map(({ tab }) => tab),
  };
};

export const shouldShowFlaggedCancellationMenuItem = (menuKey) =>
  FLAGGED_CANCELLATIONS_UI_VISIBLE || menuKey !== 'cancel-policies';
